import * as React from "react";
import { Button } from "@/components/ui/button";
import { Plus, ClipboardList, FolderOpen } from "lucide-react";
import { Link } from "react-router-dom";
import StudentAssignments from "./StudentAssignments";
import StudentSubmissions from "./StudentSubmissions";

const ProjectView: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<
    "assignments" | "submissions"
  >("assignments");
  return (
    <div className="sm:min-h-screen bg-background pt-4 sm:pt-0 p-4 md:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100">
              Projects & Assignments
            </h1>
            <div className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2 mt-1">
              <span>Dashboard</span>
              <span>/</span>
              <span className="text-green-600 dark:text-green-400 font-medium">
                Projects
              </span>
            </div>
          </div>

          {activeTab === "submissions" && (
            <Link to="/projects/add">
              <Button className="flex items-center gap-2 bg-green-600 hover:bg-green-700">
                <Plus className="w-4 h-4" />
                Add New Submission
              </Button>
            </Link>
          )}
        </div>

        {/* Tabs */}
        <div className="flex gap-2 border-b border-gray-200 dark:border-gray-700">
          <button
            onClick={() => setActiveTab("assignments")}
            className={`flex items-center gap-2 px-6 py-3 font-medium transition-all ${
              activeTab === "assignments"
                ? "text-green-600 dark:text-green-400 border-b-2 border-green-600 dark:border-green-400"
                : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
            }`}
          >
            <ClipboardList size={18} />
            Projects
          </button>
          <button
            onClick={() => setActiveTab("submissions")}
            className={`flex items-center gap-2 px-6 py-3 font-medium transition-all ${
              activeTab === "submissions"
                ? "text-green-600 dark:text-green-400 border-b-2 border-green-600 dark:border-green-400"
                : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
            }`}
          >
            <FolderOpen size={18} />
            My Submissions
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "assignments" ? (
          /* Assignments Tab */
          <StudentAssignments />
        ) : (
          /* Submissions Tab */
          <StudentSubmissions />
        )}
      </div>
    </div>
  );
};

export default ProjectView;
